/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!********************************************!*\
  !*** ./src/assets/js/hero-video-banner.js ***!
  \********************************************/
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var HeroVideoSection = /*#__PURE__*/function () {
  function HeroVideoSection() {
    var _this = this;

    _classCallCheck(this, HeroVideoSection);

    _defineProperty(this, "onStartVideo", function (video, section) {
      var videoContainer = section.querySelector(_this.selectors.videoContainer);

      if (videoContainer) {
        videoContainer.classList.add(_this.modificators.playing);
        video.play();
      }
    });

    _defineProperty(this, "onStopVideo", function (video, section) {
      var videoContainer = section.querySelector(_this.selectors.videoContainer);

      if (videoContainer) {
        videoContainer.classList.remove(_this.modificators.playing);
        video.pause();
      }
    });

    this.selectors = {
      section: ".hero-video-banner",
      mobileVideo: ".video-mobile",
      videoContainer: ".fullscreen-video-wrap",
      playBtn: ".play-btn"
    };
    this.modificators = {
      active: "active",
      playing: "playing"
    };
  }

  _createClass(HeroVideoSection, [{
    key: "initListeners",
    value: function initListeners(section) {
      var _this2 = this;

      var mobileVideo = section.querySelector(this.selectors.mobileVideo);
      var playBtn = section.querySelector(this.selectors.playBtn);

      if (mobileVideo) {
        mobileVideo.addEventListener('ended', function () {
          var wrapper = section.querySelector(_this2.selectors.videoContainer);
          wrapper.classList.remove(_this2.modificators.playing);
        });
        mobileVideo.addEventListener("click", function () {
          _this2.onStopVideo(mobileVideo, section);
        });
      }

      if (playBtn && mobileVideo) {
        playBtn.addEventListener('click', function () {
          _this2.onStartVideo(mobileVideo, section);
        });
      }
    }
  }, {
    key: "handleSections",
    value: function handleSections() {
      var _this3 = this;

      if (window.innerWidth <= 768) {
        var sections = document.querySelectorAll(this.selectors.section);
        if (!sections.length) return;
        sections.forEach(function (section) {
          _this3.initListeners(section);
        });
      }
    }
  }]);

  return HeroVideoSection;
}();

document.addEventListener("DOMContentLoaded", function () {
  window.HeroVideoSection = new HeroVideoSection().handleSections();
});
/******/ })()
;